import { Component, NgZone, OnInit } from "@angular/core";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { setTheme } from "ngx-bootstrap/utils";
import { CommonConstant } from "./shared/constants/common.constants";
import { AuthService } from "./shared/services/auth/auth.service";
import { CommonService } from "./shared/services/common/common.service";
import { GAEventService } from './shared/services/ga-service/ga-event.service';
import { DriftEventService } from './shared/services/drift-service/drift-event.service';
import { interval } from "rxjs";
import { distinctUntilChanged, filter, map, startWith, take, tap } from "rxjs/operators";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Meta, Title } from "@angular/platform-browser";
import { config } from "src/assets/config/config";
import { Country } from 'src/app/shared/country.type';
import { NgxUiLoaderService } from "ngx-ui-loader";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  visitedPages: string[] = [];
  isNotFoundPage = false;
  idleState = 'Not started.';
  timedOut = false;
  title = "digital-ivr-ui";
  isEmailContentRoute: boolean = false;
  redirectToQueryParam: string | null = null;
  pageFeedbackTitle: any;
  environmentData: any;
  country: string;
  public countryData: any;
  navigationStart$ = this.router.events.pipe(
    filter(event => event instanceof NavigationStart),
    startWith(null),// Start with something, because the app doesn't fire this on appload, only on subsequent route changes
    tap(event => {
    }/* Place code to track NavigationStart here */),
  ).subscribe();

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    public authService: AuthService,
    public commonService: CommonService,
    public driftService: DriftEventService,
    public gaService: GAEventService,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private titleService: Title,
    private metaService: Meta,
    private ngxService: NgxUiLoaderService
    ) {
   
    setTheme("bs4");
    this.ngZone.runOutsideAngular(() => {
      // Check very regularly to see if the pending macrotasks have all cleared
      interval(10)
        .pipe(
          startWith(0), // So that we don't initially wait
          // To prevent a memory leak on two closely times route changes, take until the next nav start
          // takeUntil(this.navigationStart$),
          // Turn the interval number into the current state of the zone
          map(() => !this.ngZone.hasPendingMacrotasks),
          // Don't emit until the zone state actually flips from `false` to `true`
          distinctUntilChanged(),
          // Filter out unstable event. Only emit once the state is stable again
          filter(stateStable => stateStable === true),
          // Complete the observable after it emits the first result
          take(1),
          tap(stateStable => {
            // FULLY RENDERED!!!!
            // Add code here to report Fully Rendered
            let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
            if(config[country].qualtricsArticleFeedback || config[country].qualtricsPageFeedback ) {
              this.commonService.initQualtrics();
            }
          })
        ).subscribe();
    });
  }

  ngOnInit(): void { 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.commonService.getSiteHistory();
      }
    });
    this.commonService.getDeviceType();
    this.commonService.getBrowserName();
    this.commonService.getVisitedPageCount();
    this.commonService.getSessionId();
    this.commonService.storeDeviceAndBrowserInfo();
    this.country = (window as any)['country']; 
    const languageMap: { [key: string]: { lang: string; country_id: string } } = {
      "sweden": { lang: "sv-se", country_id: "se" },
      "norway": { lang: "no-no", country_id: "no" },
      "finland": { lang: "fi-fi", country_id: "fi" },
      "denmark": { lang: "da-dk", country_id: "dk" },
      "germany": { lang: "de-de", country_id: "de" },
      "us": { lang: "en-us", country_id: "us" },
      "uk": { lang: "en-gb", country_id: "gb" }
    };
  
    if (this.country && languageMap[this.country]) {
      let lang = sessionStorage.getItem("selectedLanguage");
      const selectedLanguage: any = (sessionStorage.getItem("selectedLanguage") && lang?.split('-')[0] == 'en') ? this.getEnglishCode(this.country) : languageMap[this.country].lang;
      const countryId = languageMap[this.country].country_id;
  
      sessionStorage.setItem('country', this.country);
      sessionStorage.setItem('country_id', countryId);
      sessionStorage.setItem('selectedLanguage', selectedLanguage);
      
      this.translate.use(selectedLanguage);
      this.commonService.setLanguage(selectedLanguage);
    } else {
      console.log("url not found");
      this.isNotFoundPage = true;
      // const path = `isNotFoundPage = false;`;
      this.router.navigate(["/404"]);
    }
      this.environmentData = this.commonService.getEnvironmentData()
    this.titleService.setTitle(this.environmentData.title);
    this.metaService.updateTag({ name: 'description', content: this.environmentData.metaDescription });
    this.initUserIdle();
    // For GA enable
    //sessionStorage.removeItem('locationData');
    this.countryData = this.commonService.loadCountryData();
    this.driftService.init();
    let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    if(config[country].googleAnalytics) 
      this.gaService.init();
    this.commonService.language$.subscribe((res) => {
      if(res)
      this.pageFeedbackTitle = (res?.startsWith('en')) ? "Page Feedback" : "Sidfeedback";
    })
    let lang: any = sessionStorage.getItem('selectedLanguage');
      this.pageFeedbackTitle = (lang?.startsWith('en')) ? "Page Feedback" : "Sidfeedback";
      if(config[country].cgPageFeedback) {
        this.addCustGaugeScript();
      }
  }

  getEnglishCode(region: any) {
    switch(region) {
    case 'sweden': return 'en-se'
    case 'norway': return 'en-no'
    case 'germany': return 'en-de'
    case 'finland': return 'en-fi'
    case 'denmark': return 'en-dk'
    default:  return 'en-us'
    }
  }

  ngAfterViewInit (): void {
    this.driftService.init();
    let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    if(config[country].googleAnalytics) 
    this.gaService.init();
  }

  private redirectIfInvalidLanguage(): void {
    const supportedRegions = ["sv-se", "no-no", "fi-fi", "da-dk", "de-de", "en-gb"];
    const url = window.location.href;
    const urlSegments = url.split('/').filter(segment => segment);
  
    if (urlSegments.length > 2) { 
      const region = urlSegments[3];
      console.log("Detected Region:", region);
  
      if (!supportedRegions.includes(region)) {
        console.warn(`Invalid region detected: ${region}, redirecting to /404`);
        this.router.navigateByUrl('/404', { replaceUrl: true });
      }
    }
  }
  
  

  
  public triggerSurvey() {
    this.ngxService.start(); // Start loader

    try {
      let baseUrl: any = location.origin;
      let country: Country = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
      let lang = sessionStorage.getItem("selectedLanguage");
      lang = (lang?.includes('-')) ? lang.split('-')[0] : lang;
      let langCode: any = (lang == 'en') ? "en_GB" : config[country].pageFeedbackLanguage;
      let segment: any = config[country].pageFeedbackSegment;
    
      (window as any).CG.init({
        "surveyId": "b7ad3000-7204-4d84-b477-152493d95cad",
        "language": langCode,
        "params": {
          "country": this.convertFirstLetterToUpperCase(country),
          "url": baseUrl,
          "segment_a": segment,
          "email": this.environmentData?.cgEmail
        }
      });
    } catch (error) {
      console.error("Error initializing feedback:", error);
    } finally {
      this.ngxService.stop(); // Stop loader
    }
    
  }

  convertFirstLetterToUpperCase(str: string): string {
    if (!str) return str; // Check if string is empty or null
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  generateUrlWithLanguage(language: string, currentUrl: string): string {
    const redirectToParam = this.getRedirectToValue(currentUrl);
    if (redirectToParam) {
      const urlWithoutLang = currentUrl.replace(/^\/[a-z]{2}-[a-z]{2}/, '');
      return urlWithoutLang;
    }
    const parts = currentUrl.split('/');
    parts[2] = language;
    return parts.join('/');
  }

  extractLanguageFromUrl(url: string): string | null {
    const segments = url.split('/');
    if (segments.length > 1) {
      return segments[1];
    }
    return null;
  }

  private getRedirectToValue(url: string): string | null {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    return urlParams.get('redirectTo');
  }

   /**
   * @description Method to initiate user idle timout management
   */
   public initUserIdle (): void {
    // sets an idle timeout of 5 seconds, for testing purposes.
    this.idle.setIdle(CommonConstant.idleTime);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(3);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      this.reset();
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Session timed out!';
      this.timedOut = true;
      if (this.authService.isAuthenticated()) {
        const prevTab = this.commonService.getStringFromSession("previousTab");
        this.authService.doLogout(prevTab);
      }
    });

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
    });

    this.idle.onTimeoutWarning.subscribe((countdown: string) => {
      if (this.authService.isAuthenticated()) {
        this.idleState = 'User will get logged out in ' + countdown + ' seconds!'
      }
    });

    this.reset();
  }

  /**
   * @description Method to reset idle time
   */
  public reset (): void {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  
  addCustGaugeScript() {
    const script = document.createElement('script');
    script.src = 'https://survey.eu.customergauge.com/pop-up/pop-up.iife.js'; 
    script.type = 'text/javascript';
    document.head.appendChild(script);
  }
}
